import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LowerArchTableComponent } from './lower-arch-table.component';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { ComponentsModule } from 'src/app/pages/components/components.module';
import { MultiSelectCheckboxModule } from 'src/app/pages/components/multi-select-checkbox/multi-select-checkbox.module';



@NgModule({
  declarations: [LowerArchTableComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FlexModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoModule,
    ComponentsModule,
    MultiSelectCheckboxModule
  ],
  exports:[LowerArchTableComponent]
})
export class LowerArchTableModule { }
